import { createGlobalStyle } from 'styled-components';
import { Theme } from './theme';
import 'react-toastify/dist/ReactToastify.css';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  *::-webkit-scrollbar{
    width: 7px;
    background-color: transparent;
  }

  *::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: transparent;
  }

  *::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #6A49D9;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
      transition: background-color 5000s ease-in-out 0s;
      -webkit-box-shadow: 0 0 0px 1000px #fff0 inset;
  }

  .ifpa-bold {
    font-family: 'Montserrat', sans-serif;
    font-weight: 800!important;
  }

  .ifpa-semibold {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600!important;
  }

  .ifpa-medium {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500!important;
  }

  .ifpa-regular {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400!important;
  }

  .ifpa-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400!important;
    font-size: 12px;
  }

  html {
    font-size: 16px; //Tamanho da fonte na raiz
  }

  *::placeholder {
    color: ${({ theme }: { theme: Theme }) => theme.gray5};
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
  }

  body {
    -webkit-font-smoothing: antialiased;
    background-color: ${({ theme }: { theme: Theme }) => theme.body};
  }

  h1 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 800;
    font-size: 3rem; //48px
  }

  h2 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 800;
    font-size: 2.5rem; //40px
  }

  h3 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 2rem; //32px
  }

  h4 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 1.75rem; //28px
  }

  h5 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 1.5rem; //24px
  }

  h6 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 1.25rem; //20px
  }

  a, span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
  }

  button {
    font-family: 'Montserrat', sans-serif;
    font-weight: 800;
    line-height: 1.5rem; //24px
    font-size: 1rem; //16px
    text-align: center;
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }

  // Paragraphs

  p {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
  }

  .p1 {
    font-size: 1rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
  }

  .p2 {
    font-size: 0.875rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
  }

  .p3 {
    font-size: 0.75rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
  }
`;
